export const COLUMN_WIDTH = {
  time: 120,
  date: 160,
  dateTime: 180,
  yna: 80,
  number: 120,
  status: 140,
  tinyText: 200,
  text: 400,
  author: 150,
}

export const GRID_SIZE = {
  DEFAULT: 10000,
  MEDIUM: 1000,
  V2_DEFAULT: 50,
  SETTLEMENT: 100,
}
